export const CDNICOMERCIOSAPP_BANNER="/CDN/Get/CDNI_Banner_Home_Marzo_L";